<template>
  <div v-if="accounts.length > 0">
    <div class="section-title">
      <i class="fas fa-dice"></i>
      {{ $t(`home.${type}Label`) }} <label>{{ title[type] }}</label>
    </div>
    <b-carousel-list
      v-if="accounts.length > 1"
      v-model="values"
      :indicator="indicator"
      :indicator-background="indicatorBackground"
      :indicator-inside="indicatorInside"
      :indicator-mode="indicatorMode"
      :indicator-position="indicatorPosition"
      :indicator-style="indicatorStyle"
      :data="accounts"
      :arrow="arrow"
      :arrow-hover="arrowHover"
      :items-to-show="perList"
      :items-to-list="increment"
      :repeat="repeat"
      :has-drag="drag"
      :has-grayscale="gray"
      :has-opacity="opacity"
    >
      <template #item="slot">
        <div class="card slot-wrapper">
          <div
            class="card-image slot-content"
            v-bind:style="{ backgroundImage: `url(${slot.background})` }"
            @click="modalSlot(slot)"
          >
            <figure class="image slot-content--logo">
              <img :src="slot.logo" />
            </figure>
          </div>
        </div>
      </template>
    </b-carousel-list>
    <b-carousel
      v-else
      :autoplay="false"
      :indicator="false"
      :data="accounts"
      :repeat="repeat"
      :has-drag="drag"
      :pause-info="false"
    >
      <b-carousel-item v-for="(slot, i) in accounts" :key="i">
        <div class="card single-slot-wrapper">
          <div
            class="card-image single-slot-content"
            @click="modalSlot(slot)"
            v-bind:style="{ backgroundImage: `url(${slot.background})` }"
          >
            <figure>
              <img class="logo-image" :src="slot.logo" />
            </figure>
          </div>
        </div>
      </b-carousel-item>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: 'CarouselAccount',
  props: {
    type: {
      type: String, // NOTE : 'slotAccount' || 'sportAccount' || 'lottoAccount'
      default: 'slotAccount'
    },
    modalSlot: Function
  },
  data() {
    return {
      title: {
        slotAccount: '(Slot)',
        sportAccount: '(Sport + Casino)',
        lottoAccount: '(Lotto)'
      },
      indicator: true,
      indicatorBackground: true,
      indicatorInside: true,
      indicatorMode: 'hover',
      indicatorPosition: 'is-bottom',
      indicatorStyle: 'is-lines',

      arrow: true,
      arrowHover: true,
      drag: true,
      gray: false,
      opacity: false,
      values: 1,
      perList: 2.2,
      increment: 1,
      repeat: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.userInfo[this.type]
    }
  },
  updated() {
    if (this.$refs.treeExplorer)
      this.$refs.treeExplorer.goSlide(this.$refs.treeExplorer.currentIndex)
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.section-title {
  i {
    color: $light-primary;
  }
}
.slot-wrapper {
  border-radius: 10px;
  overflow: hidden;
  margin: 0 5px;
  .slot-content {
    height: 220px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    &--logo {
      position: absolute;
      bottom: 5%;
      left: 10%;
      right: 10%;
    }
  }
}
.single-slot-wrapper {
  border-radius: 10px;
  overflow: hidden;
  .single-slot-content {
    overflow: hidden;
    position: relative;
    height: 300px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .logo-image {
      position: absolute;
      pointer-events: none;
      bottom: 0%;
      left: 50%;
      width: 65%;
      transform: translateX(-50%);
    }
  }
}
</style>
